import { Dropdown, Form, Menu, message, Spin } from "antd";
import {
  LoadingOutlined,
  LockOutlined,
  LogoutOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useChangePasswordMutation, useLogoutUserMutation } from "@store/user";
import CustomModal from "@common/Modal";
import { useState } from "react";
import { getErrorMessage } from "@utils/error";

export default function ProfileDropdown({ children, isOpen, setIsOpen }) {
  const navigate = useNavigate();
  const [logoutUser, { isLoading }] = useLogoutUserMutation();
  const [changePassword, { isLoading: isChangePasswordLoading }] =
    useChangePasswordMutation();
  const [isChangePasswordOpen, setIsChangePasswordOpen] = useState(false);
  const [form] = Form.useForm();
  //handle logout user
  const handleLogout = async () => {
    if (isLoading) return;
    await logoutUser({ navigate });
  };

  //handle open change password modal
  const handleOpenChangePasswordModal = () => {
    setIsChangePasswordOpen(true);
  };

  //handle change password
  const handleChangePassword = async () => {
    try {
      const values = await form.validateFields();
      const res = await changePassword(values);
      if (res?.data?.success) {
        setIsChangePasswordOpen(false);
        await logoutUser({ navigate });

        message.success(res.data.message);
      } else {
        message.error(getErrorMessage(res, "Change password failed!"));
      }
    } catch (err) {
      message.error(getErrorMessage(err, "Change password failed!"));
    }
  };

  const formFields = [
    {
      name: "old_password",
      label: "Old Password",
      type: "password",
      placeholder: "Enter old password",
      required: true,
    },
    {
      name: "new_password",
      label: "New Password",
      type: "password",
      placeholder: "Enter new password",
      required: true,
    },
  ];

  const items = [
    {
      key: "1",
      label: (
        <Menu.Item
          key="3"
          className="!w-full !bg-white hover:!bg-transparent !font-teachers flex items-center gap-4"
          onClick={handleLogout}
        >
          <div className="flex items-center gap-4">
            {isLoading ? (
              <Spin
                size="small"
                className=""
                indicator={<LoadingOutlined className="!text-primary-tint" />}
              />
            ) : (
              <LogoutOutlined />
            )}
            <span>Logout</span>
          </div>
        </Menu.Item>
      ),
    },
    {
      key: "2",
      label: (
        <Menu.Item
          key="3"
          className="!w-full !bg-white hover:!bg-transparent !font-teachers flex items-center gap-4"
          onClick={handleOpenChangePasswordModal}
        >
          <div className="flex items-center gap-4">
            {isLoading ? (
              <Spin
                size="small"
                className=""
                indicator={<LoadingOutlined className="!text-primary-tint" />}
              />
            ) : (
              <LockOutlined />
            )}
            <span>Change Password</span>
          </div>
        </Menu.Item>
      ),
    },
  ];

  return (
    <>
      <Dropdown
        placement="bottomRight"
        overlayClassName="!p-0 !rounded-xl w-52 !bg-white"
        menu={{ items }}
        trigger={["hover", "click"]}
        open={isOpen}
        onOpenChange={(v) => setIsOpen(v)}
      >
        {children}
      </Dropdown>

      <CustomModal
        title="Change Password"
        open={isChangePasswordOpen}
        onCancel={() => setIsChangePasswordOpen(false)}
        onSubmit={handleChangePassword}
        fields={formFields}
        form={form}
        closable={false}
        confirmButtonText="Change Password"
        icon={<LockOutlined className="!text-primary-main text-xl mt-0.5" />}
        loading={isChangePasswordLoading}
      />
    </>
  );
}
